import api, { handleError } from "../index";
import { getSessionGuid } from "src/lib/tracking-cookies";

export function logoutService(apiToken) {
  return api({
    method: "POST",
    url: "/users/logout",
    headers: {
      ...api.defaults.headers,
      Authorization: `Bearer ${apiToken}`,
    },
    data: { session_guid: getSessionGuid() },
  })
    .then((response = {}) => {
      return { error: null, data: response.data };
    })
    .catch((error) => {
      const errorPayload = handleError(error);
      return {
        ...errorPayload,
        data: null,
      };
    });
}
